module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Bold-38941706e7679b3c90d6b2bb5fc80975.svg";